import { rateLimiter } from '../../utils/rateLimiter';
import { queryContract, executeContract, executePerps } from './Contract';
import { executeEvmContract, executeEvmPerps } from '../../evm/services/EvmContract';
import { Mainnet } from '@nibiruchain/nibijs';

class NibiruApiWrapper {
  constructor() {
    this.mainnet = Mainnet();
  }

  // High priority wrapper for critical operations
  async queryContractWithLimit(contract, message, priority = 'normal') {
    return rateLimiter.makeRequest(
      () => queryContract(contract, message, this.mainnet.endptTm),
      priority
    );
  }

  // Execute contract with rate limiting
  async executeContractWithLimit(
    message,
    timestamp,
    chainId,
    endpoint,
    contract,
    dispatch,
    tokenId,
    account,
    contractMessage,
    sender,
    wallet,
    funds = [],
    priority = 'normal'
  ) {
    return rateLimiter.makeRequest(
      () => executeContract(
        message,
        timestamp,
        chainId,
        endpoint,
        contract,
        dispatch,
        tokenId,
        account,
        contractMessage,
        sender,
        wallet,
        funds
      ),
      priority
    );
  }

  // Batch property queries
  async batchQueryProperties(tokenIds, priority = 'normal') {
    const batchSize = 3; // Process 3 at a time to stay under rate limit
    const results = [];
    
    for (let i = 0; i < tokenIds.length; i += batchSize) {
      const batch = tokenIds.slice(i, i + batchSize);
      const batchPromises = batch.map(tokenId => 
        this.queryContractWithLimit(
          process.env.REACT_APP_RENTAL_SMART_CONTRACT,
          { nft_info: { token_id: tokenId } },
          priority
        )
      );
      
      const batchResults = await Promise.all(batchPromises);
      results.push(...batchResults);
      
      // Small delay between batches
      if (i + batchSize < tokenIds.length) {
        await new Promise(resolve => setTimeout(resolve, 200));
      }
    }
    
    return results;
  }

  // Get queue status for monitoring
  getStatus() {
    return rateLimiter.getStatus();
  }
}

export const nibiruApi = new NibiruApiWrapper();